<template>
    <div class="container">
        <h1>Create survey</h1>
        <h4>Title</h4>
        <input type="text" id="surveyTitle" required />
        <h4>Code</h4>
        <input type="text" id="surveyCode" required />
        <h5 id="errortext">Code has already been used.</h5>
        <button @click="submit()">
            <h2>Create</h2>
        </button>
        <h5 id="fillalltext" style="text-align: center;">Please fill in all fields.</h5>
    </div>
</template>

<script>
import accountStore from "../accountStore";
import axios from "axios";
import { baseurl } from "../api";

export default {
    methods: {
        submit() {
            const inputobj = document.getElementById("surveyCode");
            const usercode = inputobj.value;
            const usertitle = document.getElementById("surveyTitle").value;

            if (usercode === "" || usertitle === "") {
                document.getElementById("fillalltext").classList.add("shown");
                return;
            }
            document.getElementById("fillalltext").classList.remove("shown");


            axios.post(baseurl + "checkcode", { code: usercode }).then((r) => {
                if (r.data.exists) {
                    document.getElementById("errortext").classList.add("shown");
                    inputobj.classList.add("errored");
                    return;
                }
                axios.post(baseurl + "createsurvey", { code: usercode, title: usertitle, p: accountStore.passcode }).then((r) => {
                    if (r.data.success) {
                        this.$router.push("/edit/" + usercode);
                    }
                });
            });
        },
    },
    created() {
        if (!accountStore.verified) {
            this.$router.push("/admin");
        }
        window.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                this.submit();
            }
        });
    },
    name: "Add",
};
</script>

<style scoped>
h4 {
    text-align: left;
    margin-bottom: 0.1rem;
    margin-left: 1.5rem;
    margin-top: 1.5rem;
}

.container {
    margin-bottom: 2rem;
}

input {
    border: 1px solid #555555;
    border-radius: 1rem;
    padding: 1rem 1rem;
    margin: 0 1rem;
    font-size: 1rem;
    font-weight: bold;
    height: 100%;
}

.errored {
    border: 1px solid #ff0000;
}

.errored:focus {
    outline-color: #ff0000;
}

button {
    background-color: #007bff;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    margin-top: 0.5rem;
}

button>h2 {
    color: #ffffff;
    margin: 0.8rem 1rem;
}

.inputrow {
    display: flex;
    align-items: center;
}

h5 {
    text-align: left;
    margin: 0.3rem 1.7rem;
    color: #c70000;
    visibility: hidden;
}

.shown {
    visibility: visible;
}
</style>
